<section *ngIf="show | async" class="document">
    <ng-container *ngIf="loading | async">
        <app-loading-spinner [loadingMessage]="'common.loading-signature' | translate" align="horizontal"></app-loading-spinner>
    </ng-container>
    <ng-container *ngIf="!(loading | async)">
        <div class="signatures">
            <div class="signature">
                <p *ngIf="hasAllUserInfo" class="s">On behalf of {{ name | async }},</p>
                <br />
                <p *ngIf="hasAllUserInfo" class="s">{{ userName | async }}</p>
                <br />
                <p *ngIf="hasAllUserInfo" class="s">{{ date | async }}</p>
                <br />
                <br />
            </div>
            <div class="signature">
                <p *ngIf="hasAllUserInfo | async" class="s">On behalf of Aptoide,</p>
                <img style="width: auto; height: auto; max-height: 100px" [src]="'/assets/img/aptoide-signature.png' | ssrAsset" alt="aptoide signature" />
            </div>
        </div>
    </ng-container>
</section>
